import * as R from 'ramda';
import React from 'react';
import {
  TextField,
  BooleanField,
  ArrayField,
  SingleFieldList,
  ChipField,
  FunctionField,
  NumberField,
  useRecordContext,
  SimpleShowLayout,
} from 'react-admin';
import DateTimeField from 'components/DateTimeField';
import TimestampFields from 'components/TimestampFields';
import LinkField from 'components/LinkField';
import MetabaseUrlField from 'components/MetabaseUrlField';
import useCheckAccess from 'hooks/useCheckAccess';
import { currentTimeZone } from 'utils/time';
import MoneyField from 'components/MoneyField';

const JobDetailsShowTab = () => {
  const record = useRecordContext();
  const checkAccess = useCheckAccess();

  if (!record) {
    return null;
  }

  return (
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <LinkField label="Primary Location" source="primary_location.id" typename="Location" />
      <MoneyField label="Minimum Hourly Rate" source="permanent_min_hourly_rate_cents" />
      <MoneyField label="Maximum Hourly Rate" source="permanent_max_hourly_rate_cents" />
      <LinkField label="Professional" source="professional_id" />
      <FunctionField
        label="Markets"
        render={(v) => R.uniq(R.map((l) => l.market?.display_name, v.locations ?? [])).join(', ')}
      />
      <FunctionField
        label="States"
        render={(v) => R.uniq(R.map((l) => l.state?.name, v.locations ?? [])).join(', ')}
      />
      <ArrayField label="Positions" source="positions">
        <SingleFieldList linkType={false}>
          <ChipField source="display_name" />
        </SingleFieldList>
      </ArrayField>
      <ArrayField label="Surgery Types" source="surgery_types">
        <SingleFieldList linkType={false}>
          <ChipField source="display_name" />
        </SingleFieldList>
      </ArrayField>
      <ArrayField label="Specialties" source="specialties">
        <SingleFieldList linkType={false}>
          <ChipField source="label" />
        </SingleFieldList>
      </ArrayField>
      <DateTimeField
        label="Starts Date"
        format="MM/dd/yyyy"
        source="starts_date"
        timeZone={currentTimeZone()}
      />
      <TextField label="Jobs Detail" source="jobs_detail" />
      <TextField label="Summary" source="permanent_summary.text" />
      <TextField label="Qualifications" source="permanent_qualifications.text" />
      <TextField label="Benefits" source="permanent_benefits.text" />
      <TextField label="Status" source="status" />
      <TextField label="Cancellation Reason" source="cancellation_reason" />
      <BooleanField label="Suspicious" source="suspicious" />
      <TimestampFields />
      {checkAccess('view', 'Audit') && <MetabaseUrlField />}
      <NumberField label="Available Professionals Count" source="available_professional_count" />
    </SimpleShowLayout>
  );
};

export default JobDetailsShowTab;
